import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost } from 'devextreme-angular/core';

/* tslint:disable:max-line-length */
class DxoAjaxRemoteServiceComponent extends NestedOption {
    get beforeSend() {
        return this._getOption('beforeSend');
    }
    set beforeSend(value) {
        this._setOption('beforeSend', value);
    }
    get complete() {
        return this._getOption('complete');
    }
    set complete(value) {
        this._setOption('complete', value);
    }
    get headers() {
        return this._getOption('headers');
    }
    set headers(value) {
        this._setOption('headers', value);
    }
    get _optionPath() {
        return 'ajaxRemoteService';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoAjaxRemoteServiceComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoAjaxRemoteServiceComponent, selector: "dxo-ajax-remote-service", inputs: { beforeSend: "beforeSend", complete: "complete", headers: "headers" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoAjaxRemoteServiceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-ajax-remote-service', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { beforeSend: [{
                type: Input
            }], complete: [{
                type: Input
            }], headers: [{
                type: Input
            }] } });
class DxoAjaxRemoteServiceModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoAjaxRemoteServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoAjaxRemoteServiceModule, declarations: [DxoAjaxRemoteServiceComponent], exports: [DxoAjaxRemoteServiceComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoAjaxRemoteServiceModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoAjaxRemoteServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoAjaxRemoteServiceComponent
                    ],
                    exports: [
                        DxoAjaxRemoteServiceComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoChartIndicatorsComponent extends NestedOption {
    get customIndicatorTypes() {
        return this._getOption('customIndicatorTypes');
    }
    set customIndicatorTypes(value) {
        this._setOption('customIndicatorTypes', value);
    }
    get _optionPath() {
        return 'chartIndicators';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoChartIndicatorsComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoChartIndicatorsComponent, selector: "dxo-chart-indicators", inputs: { customIndicatorTypes: "customIndicatorTypes" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoChartIndicatorsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-chart-indicators', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { customIndicatorTypes: [{
                type: Input
            }] } });
class DxoChartIndicatorsModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoChartIndicatorsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoChartIndicatorsModule, declarations: [DxoChartIndicatorsComponent], exports: [DxoChartIndicatorsComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoChartIndicatorsModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoChartIndicatorsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoChartIndicatorsComponent
                    ],
                    exports: [
                        DxoChartIndicatorsComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoDashboardExportComponent extends NestedOption {
    get allowExportDashboard() {
        return this._getOption('allowExportDashboard');
    }
    set allowExportDashboard(value) {
        this._setOption('allowExportDashboard', value);
    }
    get allowExportDashboardItems() {
        return this._getOption('allowExportDashboardItems');
    }
    set allowExportDashboardItems(value) {
        this._setOption('allowExportDashboardItems', value);
    }
    get onExportDialogHidden() {
        return this._getOption('onExportDialogHidden');
    }
    set onExportDialogHidden(value) {
        this._setOption('onExportDialogHidden', value);
    }
    get onExportDialogShowing() {
        return this._getOption('onExportDialogShowing');
    }
    set onExportDialogShowing(value) {
        this._setOption('onExportDialogShowing', value);
    }
    get onExportDialogShown() {
        return this._getOption('onExportDialogShown');
    }
    set onExportDialogShown(value) {
        this._setOption('onExportDialogShown', value);
    }
    get _optionPath() {
        return 'dashboardExport';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardExportComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoDashboardExportComponent, selector: "dxo-dashboard-export", inputs: { allowExportDashboard: "allowExportDashboard", allowExportDashboardItems: "allowExportDashboardItems", onExportDialogHidden: "onExportDialogHidden", onExportDialogShowing: "onExportDialogShowing", onExportDialogShown: "onExportDialogShown" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardExportComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-dashboard-export', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { allowExportDashboard: [{
                type: Input
            }], allowExportDashboardItems: [{
                type: Input
            }], onExportDialogHidden: [{
                type: Input
            }], onExportDialogShowing: [{
                type: Input
            }], onExportDialogShown: [{
                type: Input
            }] } });
class DxoDashboardExportModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardExportModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardExportModule, declarations: [DxoDashboardExportComponent], exports: [DxoDashboardExportComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardExportModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardExportModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoDashboardExportComponent
                    ],
                    exports: [
                        DxoDashboardExportComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoDashboardParameterDialogComponent extends NestedOption {
    get onDynamicLookUpValuesLoaded() {
        return this._getOption('onDynamicLookUpValuesLoaded');
    }
    set onDynamicLookUpValuesLoaded(value) {
        this._setOption('onDynamicLookUpValuesLoaded', value);
    }
    get onHidden() {
        return this._getOption('onHidden');
    }
    set onHidden(value) {
        this._setOption('onHidden', value);
    }
    get onShowing() {
        return this._getOption('onShowing');
    }
    set onShowing(value) {
        this._setOption('onShowing', value);
    }
    get onShown() {
        return this._getOption('onShown');
    }
    set onShown(value) {
        this._setOption('onShown', value);
    }
    get _optionPath() {
        return 'dashboardParameterDialog';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardParameterDialogComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoDashboardParameterDialogComponent, selector: "dxo-dashboard-parameter-dialog", inputs: { onDynamicLookUpValuesLoaded: "onDynamicLookUpValuesLoaded", onHidden: "onHidden", onShowing: "onShowing", onShown: "onShown" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardParameterDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-dashboard-parameter-dialog', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { onDynamicLookUpValuesLoaded: [{
                type: Input
            }], onHidden: [{
                type: Input
            }], onShowing: [{
                type: Input
            }], onShown: [{
                type: Input
            }] } });
class DxoDashboardParameterDialogModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardParameterDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardParameterDialogModule, declarations: [DxoDashboardParameterDialogComponent], exports: [DxoDashboardParameterDialogComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardParameterDialogModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDashboardParameterDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoDashboardParameterDialogComponent
                    ],
                    exports: [
                        DxoDashboardParameterDialogComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoDataInspectorComponent extends NestedOption {
    get allowInspectAggregatedData() {
        return this._getOption('allowInspectAggregatedData');
    }
    set allowInspectAggregatedData(value) {
        this._setOption('allowInspectAggregatedData', value);
    }
    get allowInspectRawData() {
        return this._getOption('allowInspectRawData');
    }
    set allowInspectRawData(value) {
        this._setOption('allowInspectRawData', value);
    }
    get onDialogHidden() {
        return this._getOption('onDialogHidden');
    }
    set onDialogHidden(value) {
        this._setOption('onDialogHidden', value);
    }
    get onDialogShowing() {
        return this._getOption('onDialogShowing');
    }
    set onDialogShowing(value) {
        this._setOption('onDialogShowing', value);
    }
    get onDialogShown() {
        return this._getOption('onDialogShown');
    }
    set onDialogShown(value) {
        this._setOption('onDialogShown', value);
    }
    get onGridContentReady() {
        return this._getOption('onGridContentReady');
    }
    set onGridContentReady(value) {
        this._setOption('onGridContentReady', value);
    }
    get onGridInitialized() {
        return this._getOption('onGridInitialized');
    }
    set onGridInitialized(value) {
        this._setOption('onGridInitialized', value);
    }
    get _optionPath() {
        return 'dataInspector';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataInspectorComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoDataInspectorComponent, selector: "dxo-data-inspector", inputs: { allowInspectAggregatedData: "allowInspectAggregatedData", allowInspectRawData: "allowInspectRawData", onDialogHidden: "onDialogHidden", onDialogShowing: "onDialogShowing", onDialogShown: "onDialogShown", onGridContentReady: "onGridContentReady", onGridInitialized: "onGridInitialized" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataInspectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-data-inspector', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { allowInspectAggregatedData: [{
                type: Input
            }], allowInspectRawData: [{
                type: Input
            }], onDialogHidden: [{
                type: Input
            }], onDialogShowing: [{
                type: Input
            }], onDialogShown: [{
                type: Input
            }], onGridContentReady: [{
                type: Input
            }], onGridInitialized: [{
                type: Input
            }] } });
class DxoDataInspectorModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataInspectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoDataInspectorModule, declarations: [DxoDataInspectorComponent], exports: [DxoDataInspectorComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataInspectorModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataInspectorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoDataInspectorComponent
                    ],
                    exports: [
                        DxoDataInspectorComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoDataRequestOptionsComponent extends NestedOption {
    get itemDataLoadingMode() {
        return this._getOption('itemDataLoadingMode');
    }
    set itemDataLoadingMode(value) {
        this._setOption('itemDataLoadingMode', value);
    }
    get itemDataRequestMode() {
        return this._getOption('itemDataRequestMode');
    }
    set itemDataRequestMode(value) {
        this._setOption('itemDataRequestMode', value);
    }
    get _optionPath() {
        return 'dataRequestOptions';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataRequestOptionsComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoDataRequestOptionsComponent, selector: "dxo-data-request-options", inputs: { itemDataLoadingMode: "itemDataLoadingMode", itemDataRequestMode: "itemDataRequestMode" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataRequestOptionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-data-request-options', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { itemDataLoadingMode: [{
                type: Input
            }], itemDataRequestMode: [{
                type: Input
            }] } });
class DxoDataRequestOptionsModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataRequestOptionsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoDataRequestOptionsModule, declarations: [DxoDataRequestOptionsComponent], exports: [DxoDataRequestOptionsComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataRequestOptionsModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataRequestOptionsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoDataRequestOptionsComponent
                    ],
                    exports: [
                        DxoDataRequestOptionsComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoDataSourceWizardComponent extends NestedOption {
    get allowCreateNewJsonConnection() {
        return this._getOption('allowCreateNewJsonConnection');
    }
    set allowCreateNewJsonConnection(value) {
        this._setOption('allowCreateNewJsonConnection', value);
    }
    get enableCustomSql() {
        return this._getOption('enableCustomSql');
    }
    set enableCustomSql(value) {
        this._setOption('enableCustomSql', value);
    }
    get onCustomizeDataSourceWizard() {
        return this._getOption('onCustomizeDataSourceWizard');
    }
    set onCustomizeDataSourceWizard(value) {
        this._setOption('onCustomizeDataSourceWizard', value);
    }
    get wizardSettings() {
        return this._getOption('wizardSettings');
    }
    set wizardSettings(value) {
        this._setOption('wizardSettings', value);
    }
    get _optionPath() {
        return 'dataSourceWizard';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataSourceWizardComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoDataSourceWizardComponent, selector: "dxo-data-source-wizard", inputs: { allowCreateNewJsonConnection: "allowCreateNewJsonConnection", enableCustomSql: "enableCustomSql", onCustomizeDataSourceWizard: "onCustomizeDataSourceWizard", wizardSettings: "wizardSettings" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataSourceWizardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-data-source-wizard', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { allowCreateNewJsonConnection: [{
                type: Input
            }], enableCustomSql: [{
                type: Input
            }], onCustomizeDataSourceWizard: [{
                type: Input
            }], wizardSettings: [{
                type: Input
            }] } });
class DxoDataSourceWizardModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataSourceWizardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoDataSourceWizardModule, declarations: [DxoDataSourceWizardComponent], exports: [DxoDataSourceWizardComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataSourceWizardModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDataSourceWizardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoDataSourceWizardComponent
                    ],
                    exports: [
                        DxoDataSourceWizardComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoDesignerToolbarComponent extends NestedOption {
    get onPreparing() {
        return this._getOption('onPreparing');
    }
    set onPreparing(value) {
        this._setOption('onPreparing', value);
    }
    get _optionPath() {
        return 'designerToolbar';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDesignerToolbarComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoDesignerToolbarComponent, selector: "dxo-designer-toolbar", inputs: { onPreparing: "onPreparing" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDesignerToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-designer-toolbar', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { onPreparing: [{
                type: Input
            }] } });
class DxoDesignerToolbarModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDesignerToolbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoDesignerToolbarModule, declarations: [DxoDesignerToolbarComponent], exports: [DxoDesignerToolbarComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDesignerToolbarModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoDesignerToolbarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoDesignerToolbarComponent
                    ],
                    exports: [
                        DxoDesignerToolbarComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoExtensionsComponent extends NestedOption {
    get chartIndicators() {
        return this._getOption('chartIndicators');
    }
    set chartIndicators(value) {
        this._setOption('chartIndicators', value);
    }
    get dashboardExport() {
        return this._getOption('dashboardExport');
    }
    set dashboardExport(value) {
        this._setOption('dashboardExport', value);
    }
    get dashboardParameterDialog() {
        return this._getOption('dashboardParameterDialog');
    }
    set dashboardParameterDialog(value) {
        this._setOption('dashboardParameterDialog', value);
    }
    get dataInspector() {
        return this._getOption('dataInspector');
    }
    set dataInspector(value) {
        this._setOption('dataInspector', value);
    }
    get dataSourceWizard() {
        return this._getOption('dataSourceWizard');
    }
    set dataSourceWizard(value) {
        this._setOption('dataSourceWizard', value);
    }
    get designerToolbar() {
        return this._getOption('designerToolbar');
    }
    set designerToolbar(value) {
        this._setOption('designerToolbar', value);
    }
    get itemBindingPanel() {
        return this._getOption('itemBindingPanel');
    }
    set itemBindingPanel(value) {
        this._setOption('itemBindingPanel', value);
    }
    get itemOptionsPanel() {
        return this._getOption('itemOptionsPanel');
    }
    set itemOptionsPanel(value) {
        this._setOption('itemOptionsPanel', value);
    }
    get mobileLayout() {
        return this._getOption('mobileLayout');
    }
    set mobileLayout(value) {
        this._setOption('mobileLayout', value);
    }
    get textBoxItemEditor() {
        return this._getOption('textBoxItemEditor');
    }
    set textBoxItemEditor(value) {
        this._setOption('textBoxItemEditor', value);
    }
    get viewerApi() {
        return this._getOption('viewerApi');
    }
    set viewerApi(value) {
        this._setOption('viewerApi', value);
    }
    get _optionPath() {
        return 'extensions';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoExtensionsComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoExtensionsComponent, selector: "dxo-extensions", inputs: { chartIndicators: "chartIndicators", dashboardExport: "dashboardExport", dashboardParameterDialog: "dashboardParameterDialog", dataInspector: "dataInspector", dataSourceWizard: "dataSourceWizard", designerToolbar: "designerToolbar", itemBindingPanel: "itemBindingPanel", itemOptionsPanel: "itemOptionsPanel", mobileLayout: "mobileLayout", textBoxItemEditor: "textBoxItemEditor", viewerApi: "viewerApi" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoExtensionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-extensions', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { chartIndicators: [{
                type: Input
            }], dashboardExport: [{
                type: Input
            }], dashboardParameterDialog: [{
                type: Input
            }], dataInspector: [{
                type: Input
            }], dataSourceWizard: [{
                type: Input
            }], designerToolbar: [{
                type: Input
            }], itemBindingPanel: [{
                type: Input
            }], itemOptionsPanel: [{
                type: Input
            }], mobileLayout: [{
                type: Input
            }], textBoxItemEditor: [{
                type: Input
            }], viewerApi: [{
                type: Input
            }] } });
class DxoExtensionsModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoExtensionsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoExtensionsModule, declarations: [DxoExtensionsComponent], exports: [DxoExtensionsComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoExtensionsModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoExtensionsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoExtensionsComponent
                    ],
                    exports: [
                        DxoExtensionsComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoFetchRemoteServiceComponent extends NestedOption {
    get beforeSend() {
        return this._getOption('beforeSend');
    }
    set beforeSend(value) {
        this._setOption('beforeSend', value);
    }
    get headers() {
        return this._getOption('headers');
    }
    set headers(value) {
        this._setOption('headers', value);
    }
    get _optionPath() {
        return 'fetchRemoteService';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoFetchRemoteServiceComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoFetchRemoteServiceComponent, selector: "dxo-fetch-remote-service", inputs: { beforeSend: "beforeSend", headers: "headers" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoFetchRemoteServiceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-fetch-remote-service', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { beforeSend: [{
                type: Input
            }], headers: [{
                type: Input
            }] } });
class DxoFetchRemoteServiceModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoFetchRemoteServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoFetchRemoteServiceModule, declarations: [DxoFetchRemoteServiceComponent], exports: [DxoFetchRemoteServiceComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoFetchRemoteServiceModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoFetchRemoteServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoFetchRemoteServiceComponent
                    ],
                    exports: [
                        DxoFetchRemoteServiceComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoItemBindingPanelComponent extends NestedOption {
    get onCustomizeDataItemContainerSections() {
        return this._getOption('onCustomizeDataItemContainerSections');
    }
    set onCustomizeDataItemContainerSections(value) {
        this._setOption('onCustomizeDataItemContainerSections', value);
    }
    get _optionPath() {
        return 'itemBindingPanel';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoItemBindingPanelComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoItemBindingPanelComponent, selector: "dxo-item-binding-panel", inputs: { onCustomizeDataItemContainerSections: "onCustomizeDataItemContainerSections" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoItemBindingPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-item-binding-panel', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { onCustomizeDataItemContainerSections: [{
                type: Input
            }] } });
class DxoItemBindingPanelModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoItemBindingPanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoItemBindingPanelModule, declarations: [DxoItemBindingPanelComponent], exports: [DxoItemBindingPanelComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoItemBindingPanelModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoItemBindingPanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoItemBindingPanelComponent
                    ],
                    exports: [
                        DxoItemBindingPanelComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoItemOptionsPanelComponent extends NestedOption {
    get onCustomizeSections() {
        return this._getOption('onCustomizeSections');
    }
    set onCustomizeSections(value) {
        this._setOption('onCustomizeSections', value);
    }
    get _optionPath() {
        return 'itemOptionsPanel';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoItemOptionsPanelComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoItemOptionsPanelComponent, selector: "dxo-item-options-panel", inputs: { onCustomizeSections: "onCustomizeSections" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoItemOptionsPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-item-options-panel', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { onCustomizeSections: [{
                type: Input
            }] } });
class DxoItemOptionsPanelModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoItemOptionsPanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoItemOptionsPanelModule, declarations: [DxoItemOptionsPanelComponent], exports: [DxoItemOptionsPanelComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoItemOptionsPanelModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoItemOptionsPanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoItemOptionsPanelComponent
                    ],
                    exports: [
                        DxoItemOptionsPanelComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoMobileLayoutComponent extends NestedOption {
    get mobileLayoutEnabled() {
        return this._getOption('mobileLayoutEnabled');
    }
    set mobileLayoutEnabled(value) {
        this._setOption('mobileLayoutEnabled', value);
    }
    get _optionPath() {
        return 'mobileLayout';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoMobileLayoutComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoMobileLayoutComponent, selector: "dxo-mobile-layout", inputs: { mobileLayoutEnabled: "mobileLayoutEnabled" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoMobileLayoutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-mobile-layout', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { mobileLayoutEnabled: [{
                type: Input
            }] } });
class DxoMobileLayoutModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoMobileLayoutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoMobileLayoutModule, declarations: [DxoMobileLayoutComponent], exports: [DxoMobileLayoutComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoMobileLayoutModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoMobileLayoutModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoMobileLayoutComponent
                    ],
                    exports: [
                        DxoMobileLayoutComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoTextBoxItemEditorComponent extends NestedOption {
    get onRichEditCreated() {
        return this._getOption('onRichEditCreated');
    }
    set onRichEditCreated(value) {
        this._setOption('onRichEditCreated', value);
    }
    get onRichEditOptionsPrepared() {
        return this._getOption('onRichEditOptionsPrepared');
    }
    set onRichEditOptionsPrepared(value) {
        this._setOption('onRichEditOptionsPrepared', value);
    }
    get _optionPath() {
        return 'textBoxItemEditor';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoTextBoxItemEditorComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoTextBoxItemEditorComponent, selector: "dxo-text-box-item-editor", inputs: { onRichEditCreated: "onRichEditCreated", onRichEditOptionsPrepared: "onRichEditOptionsPrepared" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoTextBoxItemEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-text-box-item-editor', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { onRichEditCreated: [{
                type: Input
            }], onRichEditOptionsPrepared: [{
                type: Input
            }] } });
class DxoTextBoxItemEditorModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoTextBoxItemEditorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoTextBoxItemEditorModule, declarations: [DxoTextBoxItemEditorComponent], exports: [DxoTextBoxItemEditorComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoTextBoxItemEditorModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoTextBoxItemEditorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoTextBoxItemEditorComponent
                    ],
                    exports: [
                        DxoTextBoxItemEditorComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoViewerApiComponent extends NestedOption {
    get onDashboardTitleToolbarUpdated() {
        return this._getOption('onDashboardTitleToolbarUpdated');
    }
    set onDashboardTitleToolbarUpdated(value) {
        this._setOption('onDashboardTitleToolbarUpdated', value);
    }
    get onItemActionAvailabilityChanged() {
        return this._getOption('onItemActionAvailabilityChanged');
    }
    set onItemActionAvailabilityChanged(value) {
        this._setOption('onItemActionAvailabilityChanged', value);
    }
    get onItemCaptionToolbarUpdated() {
        return this._getOption('onItemCaptionToolbarUpdated');
    }
    set onItemCaptionToolbarUpdated(value) {
        this._setOption('onItemCaptionToolbarUpdated', value);
    }
    get onItemClick() {
        return this._getOption('onItemClick');
    }
    set onItemClick(value) {
        this._setOption('onItemClick', value);
    }
    get onItemDrillDownStateChanged() {
        return this._getOption('onItemDrillDownStateChanged');
    }
    set onItemDrillDownStateChanged(value) {
        this._setOption('onItemDrillDownStateChanged', value);
    }
    get onItemElementCustomColor() {
        return this._getOption('onItemElementCustomColor');
    }
    set onItemElementCustomColor(value) {
        this._setOption('onItemElementCustomColor', value);
    }
    get onItemMasterFilterStateChanged() {
        return this._getOption('onItemMasterFilterStateChanged');
    }
    set onItemMasterFilterStateChanged(value) {
        this._setOption('onItemMasterFilterStateChanged', value);
    }
    get onItemSelectionChanged() {
        return this._getOption('onItemSelectionChanged');
    }
    set onItemSelectionChanged(value) {
        this._setOption('onItemSelectionChanged', value);
    }
    get onItemVisualInteractivity() {
        return this._getOption('onItemVisualInteractivity');
    }
    set onItemVisualInteractivity(value) {
        this._setOption('onItemVisualInteractivity', value);
    }
    get onItemWidgetCreated() {
        return this._getOption('onItemWidgetCreated');
    }
    set onItemWidgetCreated(value) {
        this._setOption('onItemWidgetCreated', value);
    }
    get onItemWidgetOptionsPrepared() {
        return this._getOption('onItemWidgetOptionsPrepared');
    }
    set onItemWidgetOptionsPrepared(value) {
        this._setOption('onItemWidgetOptionsPrepared', value);
    }
    get onItemWidgetUpdated() {
        return this._getOption('onItemWidgetUpdated');
    }
    set onItemWidgetUpdated(value) {
        this._setOption('onItemWidgetUpdated', value);
    }
    get onItemWidgetUpdating() {
        return this._getOption('onItemWidgetUpdating');
    }
    set onItemWidgetUpdating(value) {
        this._setOption('onItemWidgetUpdating', value);
    }
    get onSelectedTabPageChanged() {
        return this._getOption('onSelectedTabPageChanged');
    }
    set onSelectedTabPageChanged(value) {
        this._setOption('onSelectedTabPageChanged', value);
    }
    get _optionPath() {
        return 'viewerApi';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoViewerApiComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoViewerApiComponent, selector: "dxo-viewer-api", inputs: { onDashboardTitleToolbarUpdated: "onDashboardTitleToolbarUpdated", onItemActionAvailabilityChanged: "onItemActionAvailabilityChanged", onItemCaptionToolbarUpdated: "onItemCaptionToolbarUpdated", onItemClick: "onItemClick", onItemDrillDownStateChanged: "onItemDrillDownStateChanged", onItemElementCustomColor: "onItemElementCustomColor", onItemMasterFilterStateChanged: "onItemMasterFilterStateChanged", onItemSelectionChanged: "onItemSelectionChanged", onItemVisualInteractivity: "onItemVisualInteractivity", onItemWidgetCreated: "onItemWidgetCreated", onItemWidgetOptionsPrepared: "onItemWidgetOptionsPrepared", onItemWidgetUpdated: "onItemWidgetUpdated", onItemWidgetUpdating: "onItemWidgetUpdating", onSelectedTabPageChanged: "onSelectedTabPageChanged" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoViewerApiComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-viewer-api', template: '', providers: [NestedOptionHost] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; }, propDecorators: { onDashboardTitleToolbarUpdated: [{
                type: Input
            }], onItemActionAvailabilityChanged: [{
                type: Input
            }], onItemCaptionToolbarUpdated: [{
                type: Input
            }], onItemClick: [{
                type: Input
            }], onItemDrillDownStateChanged: [{
                type: Input
            }], onItemElementCustomColor: [{
                type: Input
            }], onItemMasterFilterStateChanged: [{
                type: Input
            }], onItemSelectionChanged: [{
                type: Input
            }], onItemVisualInteractivity: [{
                type: Input
            }], onItemWidgetCreated: [{
                type: Input
            }], onItemWidgetOptionsPrepared: [{
                type: Input
            }], onItemWidgetUpdated: [{
                type: Input
            }], onItemWidgetUpdating: [{
                type: Input
            }], onSelectedTabPageChanged: [{
                type: Input
            }] } });
class DxoViewerApiModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoViewerApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoViewerApiModule, declarations: [DxoViewerApiComponent], exports: [DxoViewerApiComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoViewerApiModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoViewerApiModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoViewerApiComponent
                    ],
                    exports: [
                        DxoViewerApiComponent
                    ],
                }]
        }] });

/* tslint:disable:max-line-length */
class DxoIDashboardDataSourceWizardSettings extends NestedOption {
    get enableFederationDataSource() {
        return this._getOption('enableFederationDataSource');
    }
    set enableFederationDataSource(value) {
        this._setOption('enableFederationDataSource', value);
    }
    get enableJsonDataSource() {
        return this._getOption('enableJsonDataSource');
    }
    set enableJsonDataSource(value) {
        this._setOption('enableJsonDataSource', value);
    }
    get enableOlapDataSource() {
        return this._getOption('enableOlapDataSource');
    }
    set enableOlapDataSource(value) {
        this._setOption('enableOlapDataSource', value);
    }
    get enableSqlDataSource() {
        return this._getOption('enableSqlDataSource');
    }
    set enableSqlDataSource(value) {
        this._setOption('enableSqlDataSource', value);
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoIDashboardDataSourceWizardSettings, deps: null, target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoIDashboardDataSourceWizardSettings, selector: "ng-component", usesInheritance: true, ngImport: i0, template: '', isInline: true });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoIDashboardDataSourceWizardSettings, decorators: [{
            type: Component,
            args: [{
                    template: ''
                }]
        }] });

/* tslint:disable:max-line-length */
/* tslint:disable:use-input-property-decorator */
class DxoWizardSettingsComponent extends DxoIDashboardDataSourceWizardSettings {
    get _optionPath() {
        return 'wizardSettings';
    }
    constructor(parentOptionHost, optionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
        this._addRecreatedComponent();
    }
    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoWizardSettingsComponent, deps: [{ token: i1.NestedOptionHost, host: true, skipSelf: true }, { token: i1.NestedOptionHost, host: true }], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DxoWizardSettingsComponent, selector: "dxo-wizard-settings", inputs: { enableFederationDataSource: "enableFederationDataSource", enableJsonDataSource: "enableJsonDataSource", enableOlapDataSource: "enableOlapDataSource", enableSqlDataSource: "enableSqlDataSource" }, providers: [NestedOptionHost], usesInheritance: true, ngImport: i0, template: '', isInline: true, styles: [""] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoWizardSettingsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dxo-wizard-settings', template: '', providers: [NestedOptionHost], inputs: [
                        'enableFederationDataSource',
                        'enableJsonDataSource',
                        'enableOlapDataSource',
                        'enableSqlDataSource'
                    ] }]
        }], ctorParameters: function () { return [{ type: i1.NestedOptionHost, decorators: [{
                    type: SkipSelf
                }, {
                    type: Host
                }] }, { type: i1.NestedOptionHost, decorators: [{
                    type: Host
                }] }]; } });
class DxoWizardSettingsModule {
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoWizardSettingsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    /** @nocollapse */ static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DxoWizardSettingsModule, declarations: [DxoWizardSettingsComponent], exports: [DxoWizardSettingsComponent] });
    /** @nocollapse */ static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoWizardSettingsModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DxoWizardSettingsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DxoWizardSettingsComponent
                    ],
                    exports: [
                        DxoWizardSettingsComponent
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DxoAjaxRemoteServiceComponent, DxoAjaxRemoteServiceModule, DxoChartIndicatorsComponent, DxoChartIndicatorsModule, DxoDashboardExportComponent, DxoDashboardExportModule, DxoDashboardParameterDialogComponent, DxoDashboardParameterDialogModule, DxoDataInspectorComponent, DxoDataInspectorModule, DxoDataRequestOptionsComponent, DxoDataRequestOptionsModule, DxoDataSourceWizardComponent, DxoDataSourceWizardModule, DxoDesignerToolbarComponent, DxoDesignerToolbarModule, DxoExtensionsComponent, DxoExtensionsModule, DxoFetchRemoteServiceComponent, DxoFetchRemoteServiceModule, DxoItemBindingPanelComponent, DxoItemBindingPanelModule, DxoItemOptionsPanelComponent, DxoItemOptionsPanelModule, DxoMobileLayoutComponent, DxoMobileLayoutModule, DxoTextBoxItemEditorComponent, DxoTextBoxItemEditorModule, DxoViewerApiComponent, DxoViewerApiModule, DxoWizardSettingsComponent, DxoWizardSettingsModule };
